import { Avatar } from "antd";
import "./avatar.scss";

function AvatarComp({
  onClick,
  src,
  icon,
  size = 24,
  children,
  blue,
  orange,
  userDetails,
  shape = "",
}) {
  const bgClass = orange ? "bg-orange" : blue ? "bg-blue" : "bg-green";

  return (
    <Avatar
      icon={icon}
      size={size}
      className={`avatar-comp ${bgClass} ${icon ? "icon-avatar" : ""} ${
        userDetails ? " user" : ""
      } `}
      src={src}
      shape={shape}
      onClick={onClick}
    >
      {children}
    </Avatar>
  );
}

export default AvatarComp;
